import { Component, inject, input, OnDestroy, OnInit, signal } from "@angular/core";
import { FuseAlertService } from "@fuse/components/alert";
import { SharedModule } from "@shared/shared.module";
import { AppWideAlertService } from "./app-wide-alert.service";
import { MatButtonModule } from "@angular/material/button";
import { MatSnackBar, MatSnackBarAction, MatSnackBarActions, MatSnackBarHorizontalPosition, MatSnackBarLabel, MatSnackBarRef, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";
import { MatIcon } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-wide-alert-component",
  standalone: true,
  imports: [SharedModule],
  template: "",
})
export class AppwideAlertComponent {
  private __snackBar = inject(MatSnackBar);
  _appWideAlertService = inject(AppWideAlertService);
  durationInSeconds = 5;
  horizontalPosition: MatSnackBarHorizontalPosition = "center";
  verticalPosition: MatSnackBarVerticalPosition = "top";

  constructor() {
    this._appWideAlertService.$successAlertObservable.subscribe((appWideAlertModel) => {
      if (appWideAlertModel && appWideAlertModel.message) {
        this.__snackBar.openFromComponent(AppwideAlertSnackBar, {
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition,
          duration: appWideAlertModel.duration ? appWideAlertModel.duration : 5000,
          data: {
            mode: "success",
            message: appWideAlertModel.message,
          },
        });
      } else {
        this.__snackBar.dismiss();
      }
    });

    this._appWideAlertService.$errorAlertObservable.subscribe((appWideAlertModel) => {
      if (appWideAlertModel && appWideAlertModel.message) {
        this.__snackBar.openFromComponent(AppwideAlertSnackBar, {
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition,
          duration: appWideAlertModel.duration ? appWideAlertModel.duration : 5000,
          data: {
            mode: "error",
            message: appWideAlertModel.message,
          },
        });
      } else {
        this.__snackBar.dismiss();
      }
    });
  }
}

@Component({
  selector: "app-wide-alert-snackbar-component",
  templateUrl: "./app-wide-alert-snackbar.component.html",
  standalone: true,
  styles: `
    :host {
      display: flex;
    }
    .sucess-snack-text-color {
      color: green;
    }
    .error-snack-text-color {
      color: green;
    }
  `,
  imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction, MatIcon, MatProgressBarModule, CommonModule],
})
export class AppwideAlertSnackBar implements OnInit, OnDestroy {
  dashOffset: number = 100;
  private timer: any;
  mode = signal<string>("success");
  message = signal<string>("");

  constructor(public snackBarRef: MatSnackBarRef<AppwideAlertSnackBar>) {
    // Get the duration from snackbar config
    const duration = snackBarRef.containerInstance.snackBarConfig.duration || 5000;

    const startTime = Date.now();
    this.timer = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      this.dashOffset = 100 * (1 - progress);

      if (progress >= 1) {
        clearInterval(this.timer);
        this.snackBarRef.dismiss();
      }
    }, 16);
  }

  ngOnInit(): void {
    let inData = this.snackBarRef.containerInstance.snackBarConfig.data;
    if (inData && inData["mode"]) {
      this.mode.set(inData["mode"]);
    }
    if (inData && inData["message"]) {
      this.message.set(inData["message"]);
    }
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
